<script setup lang="ts">
  import { onMounted, ref } from 'vue'
  import { RouterView, useRoute, useRouter } from 'vue-router'
  import { useCookies } from '@vueuse/integrations/useCookies'
  import LoginScreen from '@/pages/LoginScreen.vue'
  import { useStore } from './utils/store'
  import { UIContentWrap } from '@gohighlevel/ghl-ui'
  import NavMenu from './components/NavMenu.vue'
  import { useFavicon, useTitle } from '@vueuse/core'
  import { useI18n } from 'vue-i18n'

  const { t } = useI18n()
  const router = useRouter()

  const route = useRoute()
  const title = useTitle()
  const favicon = useFavicon()
  const store = useStore()

  const is404 = ref(false)

  onMounted(() => {
    const cookies = useCookies(['storeInfo', 'token'])

    const storeInfo = cookies.get('storeInfo')
    if (!storeInfo) {
      is404.value = true
      return
    }
    const path = storeInfo.path
    const locationId = storeInfo.locationId
    const storeId = storeInfo.storeId
    const name = storeInfo.name
    const icon = storeInfo.favicon
    const tokenFromStorage = cookies.get(`token_${storeId}`)
    let userFromStorage = { name: '', email: '' }
    try {
      userFromStorage = JSON.parse(localStorage.getItem(`user_${storeId}`) ?? '{}')
    } catch {
      localStorage.removeItem(`user_${storeId}`)
    }

    if (!storeId || !locationId) {
      is404.value = true
      return
    }

    store.locationId.value = locationId
    store.storeId.value = storeId

    if (name) {
      title.value = name
      store.storeName.value = name
    }
    if (favicon) {
      favicon.value = icon
    }

    if (route.query.login === 'true') {
      store.isLogin.value = true
      return
    }

    if (path) {
      router.push(path)
    }
    if (tokenFromStorage) {
      store.token.value = tokenFromStorage
    }
    if (userFromStorage) {
      store.user.value = userFromStorage
    }
  })
</script>

<template>
  <div id="app">
    <UIContentWrap>
      <div class="container">
        <div v-if="is404" class="flex items-center justify-center min-h-screen">
          <h1 class="text-8xl">{{ t('app.notFound') }}</h1>
        </div>
        <div v-else>
          <NavMenu v-if="!store.isLogin.value && route.path !== '/login'" />
          <RouterView v-if="!store.isLogin.value" />
          <LoginScreen v-else />
        </div>
      </div>
      <Notification />
    </UIContentWrap>
  </div>
</template>
